export const aciBill = {
    iconName: 'bill',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 21 24' },
        path: [
            {
                attr: {
                    d: 'M20.13 6.386L14.3.694C13.882.278 13.327 0 12.771 0H2.222C.971 0 0 .972 0 2.221v19.297c0 1.25.972 2.222 2.221 2.222h16.382c1.25 0 2.221-.972 2.221-2.221V7.912c0-.555-.277-1.11-.694-1.527zm-.972.972H14.16c-.416 0-.832-.417-.832-.833V1.666l5.83 5.692zm-.555 14.855H2.221c-.416 0-.833-.417-.833-.833V2.22c0-.416.417-.833.833-.833h9.718v5.276c0 1.25.972 2.221 2.222 2.221h5.275v12.633c0 .278-.416.695-.833.695z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M5.831 12.911v.417c0 .416.278.694.695.694.416 0 .694-.278.694-.694v-.417c1.11-.277 2.082-1.11 2.082-2.082 0-1.25-1.25-2.222-2.776-2.222-.833 0-1.389-.416-1.389-.832 0-.417.556-.833 1.389-.833.555 0 .971.138 1.25.555.277.278.693.416.97.139.279-.278.417-.694.14-.972a3.229 3.229 0 00-1.666-1.11v-.417c0-.417-.278-.694-.694-.694-.417 0-.695.277-.695.694v.416c-1.249.278-2.082 1.11-2.082 2.083 0 1.25 1.25 2.22 2.777 2.22.833 0 1.388.417 1.388.834 0 .416-.555.833-1.388.833-.556 0-.972-.139-1.25-.555-.278-.278-.694-.417-.972-.14-.277.278-.416.695-.138.973.277.555.971.971 1.665 1.11zM16.382 14.022h-5.97c-.417 0-.694.277-.694.694 0 .416.277.694.694.694h5.97c.416 0 .694-.278.694-.694 0-.417-.278-.694-.694-.694zM16.382 18.465H5.137c-.417 0-.695.277-.695.694 0 .416.278.694.695.694h11.245c.416 0 .694-.278.694-.694 0-.417-.278-.694-.694-.694z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
